import * as eventDatesActions from './eventDatesActions'
import * as eventDateDetailsActions from './eventDateDetailsActions'
import * as localizationActions from './localizationActions'
import * as pushActions from './pushActions'
import * as modalActions from './modalActions'
import * as filterActions from './filterActions'
import * as settingsActions from './settingsActions'
import * as notificationsActions from './notificationsActions'
import * as timeZoneActions from './timeZoneActions'
import * as calendarSettingsActions from './calendarSettingsActions'
import * as fetchPosts  from './postActions'
import * as eventNotifyActions from './eventNotifyActions'

export default (store) => ({
    fetchEventDates: (state) => eventDatesActions.fetchEventDates(store),

    fetchEventDateDetails: (state, eventDateId) => eventDateDetailsActions.fetchEventDateDetails(store, eventDateId),
    showEventDateDetails: (state, eventDateId) => eventDateDetailsActions.showEventDateDetails(store, eventDateId),
    showEventDateMinimalDetails: (state, eventDateId) => eventDateDetailsActions.showEventDateMinimalDetails(store, eventDateId),
    showEventDateMenu: (state, eventDateId) => eventDateDetailsActions.showEventDateMenu(store, eventDateId),
    showEventDateModalMenu: (state, eventDateId) => eventDateDetailsActions.showEventDateModalMenu(store, eventDateId),

    fetchLocalizations: (state) => localizationActions.fetchLocalizations(store),

    subscribeToCalendar: (state) => pushActions.subscribeToCalendar(store),

    hideModalConnectionError: (state) => modalActions.hideModalConnectionError(store),
    showModalConnectionError: (state) => modalActions.showModalConnectionError(store),
    toggleModalLegend: (state) => modalActions.toggleModalLegend(store),
    showPermissionAlert: (state, show) => modalActions.showPermissionAlert(store, show),

    changeTimezone: (state, timezoneOffset) => settingsActions.changeTimezone(store, timezoneOffset),
    changeTimezoneAndFetch: (state, timezone) => settingsActions.changeTimezoneAndFetch(store, timezone),
    updateSettingsFromStorage: (state) => settingsActions.updateSettingsFromStorage(store),
    changeSettingsAndSave: (state, newSettings) => settingsActions.changeSettingsAndSave(store, newSettings),

    changeFilter: (state, filterChanges) => filterActions.changeFilter(store, filterChanges),
    changeFilterAndFetch: (state, filterChanges) => filterActions.changeFilterAndFetch(store, filterChanges),
    changeShowAdvancedFilter: (state, show) => filterActions.changeShowAdvancedFilter(store, show),
    changeShowMobileFilter: (state, show) => filterActions.changeShowMobileFilter(store, show),

    initEventNotifications: (state) => notificationsActions.initEventNotifications(store),
    subscribeToEvent: (state, eventId) => notificationsActions.subscribeToEvent(store, eventId),
    unsubscribeToEvent: (state, eventId) => notificationsActions.unsubscribeToEvent(store, eventId),

    initTimezones: (state) => timeZoneActions.initTimezones(store),
    changeTimeFormat: (state, timeFormat) => timeZoneActions.changeTimeFormat(store, timeFormat),

    openCalendarSettings: (state) => calendarSettingsActions.openCalendarSettings(store),
    initSettingsListener: (state) => calendarSettingsActions.initSettingsListener(store),
    showSucessMessage:(state) => calendarSettingsActions.showSucessMessage(store),

    showEventNotifyModal:(state, show) => eventNotifyActions.showEventNotifyModal(store, show),

    fetchPosts: (state) => fetchPosts(store)
})
